var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "#FFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 512,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 512,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 48,
    y1: 0,
    x2: 48,
    y2: 512,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 64,
    y1: 0,
    x2: 64,
    y2: 512,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 80,
    y1: 0,
    x2: 80,
    y2: 512,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 96,
    y1: 0,
    x2: 96,
    y2: 512,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 112,
    y1: 0,
    x2: 112,
    y2: 512,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 128,
    y1: 0,
    x2: 128,
    y2: 512,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 144,
    y1: 0,
    x2: 144,
    y2: 512,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 160,
    y1: 0,
    x2: 160,
    y2: 512,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 176,
    y1: 0,
    x2: 176,
    y2: 512,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 192,
    y1: 0,
    x2: 192,
    y2: 512,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 208,
    y1: 0,
    x2: 208,
    y2: 512,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 224,
    y1: 0,
    x2: 224,
    y2: 512,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 240,
    y1: 0,
    x2: 240,
    y2: 512,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 256,
    y1: 0,
    x2: 256,
    y2: 512,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 272,
    y1: 0,
    x2: 272,
    y2: 512,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 288,
    y1: 0,
    x2: 288,
    y2: 512,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 304,
    y1: 0,
    x2: 304,
    y2: 512,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 320,
    y1: 0,
    x2: 320,
    y2: 512,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 336,
    y1: 0,
    x2: 336,
    y2: 512,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 352,
    y1: 0,
    x2: 352,
    y2: 512,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 368,
    y1: 0,
    x2: 368,
    y2: 512,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 384,
    y1: 0,
    x2: 384,
    y2: 512,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 400,
    y1: 0,
    x2: 400,
    y2: 512,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 416,
    y1: 0,
    x2: 416,
    y2: 512,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 432,
    y1: 0,
    x2: 432,
    y2: 512,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 448,
    y1: 0,
    x2: 448,
    y2: 512,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 464,
    y1: 0,
    x2: 464,
    y2: 512,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 480,
    y1: 0,
    x2: 480,
    y2: 512,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 496,
    y1: 0,
    x2: 496,
    y2: 512,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 16,
    x2: 512,
    y2: 16,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 32,
    x2: 512,
    y2: 32,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 48,
    x2: 512,
    y2: 48,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 64,
    x2: 512,
    y2: 64,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 80,
    x2: 512,
    y2: 80,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 96,
    x2: 512,
    y2: 96,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 112,
    x2: 512,
    y2: 112,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 128,
    x2: 512,
    y2: 128,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 144,
    x2: 512,
    y2: 144,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 160,
    x2: 512,
    y2: 160,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 176,
    x2: 512,
    y2: 176,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 192,
    x2: 512,
    y2: 192,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 208,
    x2: 512,
    y2: 208,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 224,
    x2: 512,
    y2: 224,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 240,
    x2: 512,
    y2: 240,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 256,
    x2: 512,
    y2: 256,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 272,
    x2: 512,
    y2: 272,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 288,
    x2: 512,
    y2: 288,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 304,
    x2: 512,
    y2: 304,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 320,
    x2: 512,
    y2: 320,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 336,
    x2: 512,
    y2: 336,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 352,
    x2: 512,
    y2: 352,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 368,
    x2: 512,
    y2: 368,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 384,
    x2: 512,
    y2: 384,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 400,
    x2: 512,
    y2: 400,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 416,
    x2: 512,
    y2: 416,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 432,
    x2: 512,
    y2: 432,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 448,
    x2: 512,
    y2: 448,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 464,
    x2: 512,
    y2: 464,
    stroke: "#449FDB",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 480,
    x2: 512,
    y2: 480,
    stroke: "#449FDB",
    opacity: 1
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1,
    x1: 0,
    y1: 496,
    x2: 512,
    y2: 496,
    stroke: "#449FDB",
    opacity: 0.3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432 0h-384c-26.4 0-48 21.6-48 48v416c0 26.4 21.6 48 48 48h384c26.4 0 48-21.6 48-48v-416c0-26.4-21.6-48-48-48zM416 448h-352v-384h352v384zM128 224h224v32h-224zM128 288h224v32h-224zM128 352h224v32h-224zM128 160h224v32h-224z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/listIcon.a72e0c72711d86e52e098b0b420c6960.svg";
export { ForwardRef as ReactComponent };